(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 58671:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(40790);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Custom404; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_useragent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28010);
/* harmony import */ var _providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8710);
/* harmony import */ var _styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18754);
/* harmony import */ var _styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82913);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27101);








function Custom404(param) {
    var uaString = param.uaString;
    var ua = (0,next_useragent__WEBPACK_IMPORTED_MODULE_3__/* .useUserAgent */ .FS)(uaString);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_6__/* .SearchStoreProvider */ .YG, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__/* .RootStoreProvider */ .LD, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                    title: "Ошибка 404: страница не найдена"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .Layout */ .A, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    isOutsPage: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().header),
                                children: "Ошибка 404"
                            }),
                            isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().text),
                                        children: "Увы, либо ссылка неверна, либо страница уже удалена."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().text),
                                                children: [
                                                    "Попробуйте перезагрузить страницу",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().mobileText),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().text),
                                                        children: "или"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().textLink),
                                                        href: "/",
                                                        rel: "nofollow",
                                                        children: [
                                                            " ",
                                                            "перейти на главную"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().text),
                                        children: "Увы, либо ссылка неверна, либо страница уже удалена."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().textBottom),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().text),
                                                children: [
                                                    "Попробуйте перезагрузить страницу",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().mobileText),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().text),
                                                        children: "или"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        className: (_styles_notFoundPage_module_sass__WEBPACK_IMPORTED_MODULE_7___default().textLink),
                                                        href: "/",
                                                        rel: "nofollow",
                                                        children: [
                                                            " ",
                                                            "перейти на главную"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: !isMobile ? "/icons/404.svg" : "/icons/404mob.svg",
                                    alt: ""
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 18754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"notFoundPage_header__Kcod9","content":"notFoundPage_content__PXLLE","layout":"notFoundPage_layout__2Kq_u","img":"notFoundPage_img__YyQY8","text":"notFoundPage_text___xpn_","textLink":"notFoundPage_textLink__k7s3z","textBottom":"notFoundPage_textBottom__xD0_O","mobileText":"notFoundPage_mobileText__NQUMQ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(58671); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);